import { z, isoZ } from 'my-zod'
import { currencyEnum } from '../../internal/currency'

// Note that line charges can be positive or negative depending on whether we're doing a purchase or return.
export const CustomerOrderLineChargeReasonEnum = z.enum([
  'Confirmed',
  // Cancelled is really only relevant to order lines that are reservations
  'Cancelled',
  // Damage is really only relevant to order lines that are reservations
  'Damage'
])

export const customerOrderLineChargesModel = z.object({
  id: z.string().uuid(),
  lineId: z.string().uuid(),
  subtotalAmount: z.number(),
  subtotalCurrency: currencyEnum,
  reason: z.enum(['Confirmed', 'Cancelled', 'Damage']),
  createdDate: isoZ.instant()
})

export type customerOrderLineChargesModel = z.infer<typeof customerOrderLineChargesModel>
